import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {forgotPassword} from '../../services/auth-service';
import MinimalLayout from "../../layouts/minimal";
import Alert from "../../components/alert";
import {ErrorMessage, Field, Form, Formik} from "formik";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {forgotPasswordRequestSchema} from "../../utils/schemas";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes} from "../../utils/constants";

export default function ForgotPassword () {
  const [responseMessage, setResponseMessage] = useState({type: 'danger', message: null});
  const [submitted, setSubmitted] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    forgotPassword({
      login: values.login
    }).then((responseData) => {
     setSubmitted(true);
    }).catch(error => {
      if( error.response ){
        HelperService.handleApiErrors(error, addErrorMessage, "Obnova hesla nebola úspešná.");
      }
      HelperService.handleFormErrors(error, setErrors);
    }).finally(()=>{setSubmitting(false);});
  };

  return (
    <>
      <Section animation={HelperService.getRandomAnimation()}>
        <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xxl-4 col-lg-5">

                <div className="card">

                  <div className="card-header pt-4 pb-4 text-center bg-primary bg-pattern">
                    <Link to={AppRoutes.landing.path}>
                      <span><img src="/images/logo.png" alt="" height="50" /></span>
                    </Link>
                  </div>

                  {submitted && <div className="card-body p-4">
                    <div className={"my-2 p-2 text-center"}>
                      <span className="mdi mdi-check-circle-outline mb-2 text-success" style={{'fontSize':'50px'}}></span><br />
                      <p>Na vašu emailovú adresu sme odoslali pokyny pre obnovenie vášho hesla.</p>
                    </div>
                  </div>}

                  {!submitted && <div className="card-body p-4">

                    <div className="text-center w-75 m-auto">
                      <h4 className="text-dark-50 text-center pb-0 fw-bold">Zabudnuté heslo</h4>
                      <p className="text-muted mb-4">Zadajte prihlasovací údaj, ktorý máte priradený k aplikácii a my vám pomôžeme získať späť prístup k vášmu účtu.</p>
                    </div>

                    <Alert type={responseMessage.type} className={"my-2"}>{responseMessage.message}</Alert>

                    <Formik
                      initialValues={forgotPasswordRequestSchema.cast()}
                      validationSchema={forgotPasswordRequestSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, errors, touched }) => (
                        <Form>
                          <div className="mb-3">
                            <label htmlFor="login" className="form-label">Login</label>
                            <Field required
                                   name="login"
                                   placeholder="Váš prihlasovací údaj"
                                   className={`form-control ${errors.login && touched.login ? "is-invalid":""}`} />
                            <ErrorMessage name="login" component="div" className="invalid-feedback" />
                          </div>

                          <div className={"text-center"}>
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Odoslať</button>
                          </div>
                        </Form>
                      )}
                    </Formik>

                    <hr className={"mt-4 d-block"} />

                    <p className="mb-4 text-center">
                      <Link to={AppRoutes.login.path} className={"link-secondary"}>Prihlásenie</Link>
                    </p>

                  </div>}

                </div>

              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}


ForgotPassword.getLayout = function getLayout(page) {
  return (
    <MinimalLayout>
      {page}
    </MinimalLayout>
  )
}

ForgotPassword.getSEO = function getSEO() {
  return {
    title: "Obnova hesla",
  }
}
